<div class="modal">
  <ng-container>
    <div id="header">
      <div class="header-row">
        <div class="title">
          <mat-icon fontSet="material-icons-round" class="close">list_alt</mat-icon>
          <span class="kbody-huge">Course Details: Course ID {{ courseItemId }}</span>
        </div>
        <mat-icon fontSet="material-icons-round" class="close" (click)="closeModal()">close</mat-icon>
      </div>
      <div class="admin-button-row" *ngIf="!isLoading">
        <div class="btn" *ngFor="let action of actions" (click)="takeAction(action)">
          <mat-icon fontSet="material-icons-round" class="icon">{{
            action.icon
            }}</mat-icon>
          <span class="kbody-medium">{{ action.text }}</span>
        </div>
      </div>
    </div>

    <div class="content" *ngIf="!isLoading && course">
      <app-finish #finishComponent [courseItemId]="courseItemId" [Id]="Id" (isLoadingStatus)="isLoading = $event"
        [isCourseDetails]="true" [course]="course" (completeCourseSessionDetails)="
          this.completeCourseSessionDetails = $event
        "></app-finish>
      <!-- TODO: Update course details with cancel functionality -->
    </div>

    <div id="footer" class="buttons">
      <app-button id="cancel" *ngIf="showCancelButton()" [disabled]="!showCancelButtonByDateOffered()"
        matTooltip="{{cancelButtonHoverText()}}" text="Cancel Course" [class]="'red'"
        (click)="showCancelButtonByDateOffered() && showCancelButton() ? cancelCourse() : null"></app-button>
      <app-button id="reactivate" *ngIf="showRestoreButton()" text="Restore Course" [class]="'white'"
        (click)="restoreCourse()"></app-button>
      <div class="actions">
        <app-button (click)="closeModal()" text="Exit Window" [class]="'white'"></app-button>
        <app-button *ngIf="canRegister && !data.noRegistrationButtons && showButtons()" text="Register for this course"
          [icon]="{ materialIcon: 'playlist_add_check' }" [disabled]="checkForRegistration(courseItemId)"
          [matTooltip]="checkForRegistration(courseItemId) ? 'You are already registered for this course' : ''"
          (click)="!checkForRegistration(courseItemId) ? openRegistrationModal() : null"></app-button>
        <app-button *ngIf="canWaitList && !data.noRegistrationButtons && showButtons()" text="Join Waitlist"
          [icon]="{ materialIcon: 'access_time' }" [class]="'orange'" [disabled]="checkForRegistration(courseItemId)"
          [matTooltip]="checkForRegistration(courseItemId) ? 'You are already registered for this course' : ''"
          (click)="!checkForRegistration(courseItemId) ? openWaitlistModal() : null"></app-button>
      </div>
    </div>
  </ng-container>
  <app-loading-spinner class="spinner" *ngIf="isLoading"></app-loading-spinner>
</div>

<ng-container *ngIf="!isLoading && showUploadDocumentsModal">
  <app-upload-course-documents [courseItemId]="courseItemId"
    (closeModal)="closeUploadDocumentsModal()"></app-upload-course-documents>
</ng-container>